var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "downlineRepContainer",
    staticClass: "page-wrapper downlinerep-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('pending-items-internal', {
    attrs: {
      "title": false
    }
  }), _c('div', {
    staticClass: "page-title text-upper-case"
  }, [_c('h1', [_vm._v("Downline Pending Activation")]), _c('button', {
    staticClass: "clear-search",
    on: {
      "click": _vm.clearDownline
    }
  }, [_vm._v(" Clear Search ")])]), _c('pending-downline-rep-list-filter', {
    attrs: {
      "filters": _vm.filterQuery
    },
    on: {
      "onSearch": _vm.filterData
    }
  }), _c('div', {
    staticClass: "downlinedata-card"
  }, [_c('div', {
    staticClass: "align-items-center top-pagination"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1), _c('downline-rep-list-table', {
    attrs: {
      "rows": _vm.rows,
      "is-initial-load": false
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      },
      "onSuccess": function onSuccess($event) {
        return _vm.getAll(_vm.filterQuery);
      }
    }
  }), _c('div', {
    staticClass: " align-items-center"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }